import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Bundles/Bundle'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Bundles/Bundle'
import { mediaPlatformBundlesRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Bundles/Routing'

export const mediaPlatformBundleRoute = createRoute({
  getParentRoute: () => mediaPlatformBundlesRoute,
  path: DynamicRouteParameterWPrefix.BUNDLE_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const mediaPlatformBundleLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformBundleRoute,
  id: 'mediaPlatformBundleLayout',
  component: Structure,
})

export const mediaPlatformBundleRawRoute = createRoute({
  getParentRoute: () => mediaPlatformBundleLayoutRoute,
  path: '/',
  component: Overview,
})
